import { render, staticRenderFns } from "./ErrorSeverityList.vue?vue&type=template&id=2bdfb9a0&scoped=true"
import script from "./ErrorSeverityList.vue?vue&type=script&lang=js"
export * from "./ErrorSeverityList.vue?vue&type=script&lang=js"
import style0 from "./ErrorSeverityList.vue?vue&type=style&index=0&id=2bdfb9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdfb9a0",
  null
  
)

export default component.exports